<div class="berichte-container">
  <h1 class="page-title">
    <mat-icon class="title-icon">assessment</mat-icon>
    Berichte
  </h1>

  <!-- Filter -->
  <mat-card class="filter-card">
    <mat-card-content>
      <div class="filter-row">
        <mat-form-field appearance="outline">
          <mat-label>Benutzer</mat-label>
          <mat-select [(ngModel)]="selectedUserId">
            <mat-option value="">Alle Benutzer</mat-option>
            <mat-option *ngFor="let user of users" [value]="user.id">
              {{ user.userName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Von</mat-label>
          <input matInput [matDatepicker]="pickerFrom" [formControl]="dateFrom">
          <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
          <mat-datepicker #pickerFrom></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Bis</mat-label>
          <input matInput [matDatepicker]="pickerTo" [formControl]="dateTo">
          <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
          <mat-datepicker #pickerTo></mat-datepicker>
        </mat-form-field>

        <div class="filter-actions">
          <button mat-raised-button color="primary" (click)="loadData()">
            <mat-icon>search</mat-icon> Filtern
          </button>
          <button mat-stroked-button (click)="resetFilters()">
            <mat-icon>clear</mat-icon> Zurücksetzen
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Summary Cards -->
  <div class="summary-cards" *ngIf="summary">
    <mat-card class="summary-card">
      <mat-card-content>
        <mat-icon class="summary-icon withdrawal-icon">remove_shopping_cart</mat-icon>
        <div class="summary-value">{{ summary.totalWithdrawals }}</div>
        <div class="summary-label">Entnahmen</div>
        <div class="summary-sub">{{ summary.totalWithdrawnQty }} Stück gesamt</div>
      </mat-card-content>
    </mat-card>

    <mat-card class="summary-card">
      <mat-card-content>
        <mat-icon class="summary-icon return-icon">add_shopping_cart</mat-icon>
        <div class="summary-value">{{ summary.totalReturns }}</div>
        <div class="summary-label">Rückgaben</div>
        <div class="summary-sub">{{ summary.totalReturnedQty }} Stück gesamt</div>
      </mat-card-content>
    </mat-card>

    <mat-card class="summary-card">
      <mat-card-content>
        <mat-icon class="summary-icon activity-icon">history</mat-icon>
        <div class="summary-value">{{ summary.totalActivities }}</div>
        <div class="summary-label">Aktivitäten</div>
        <div class="summary-sub">Benutzer-Aktionen</div>
      </mat-card-content>
    </mat-card>

    <mat-card class="summary-card">
      <mat-card-content>
        <mat-icon class="summary-icon balance-icon">swap_horiz</mat-icon>
        <div class="summary-value">{{ summary.totalWithdrawnQty - summary.totalReturnedQty }}</div>
        <div class="summary-label">Netto-Entnahme</div>
        <div class="summary-sub">Entnommen − Rückgabe</div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Top Users -->
  <mat-card class="top-users-card" *ngIf="summary && summary.topUsers.length > 0">
    <mat-card-header>
      <mat-card-title>
        <mat-icon>people</mat-icon> Aktivste Benutzer (Entnahmen)
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="top-users-list">
        <div class="top-user" *ngFor="let user of summary.topUsers; let i = index">
          <span class="top-user-rank">{{ i + 1 }}.</span>
          <span class="top-user-name">{{ user.userName }}</span>
          <span class="top-user-stats">{{ user.withdrawalCount }} Entnahmen ({{ user.totalQuantity }} Stk.)</span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Loading -->
  <div class="loading-overlay" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Tabs -->
  <mat-tab-group [(selectedIndex)]="selectedTab" class="data-tabs">
    <!-- Entnahmen Tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>remove_shopping_cart</mat-icon>&nbsp;Entnahmen ({{ withdrawalDataSource.data.length }})
      </ng-template>

      <div class="table-wrapper">
        <table mat-table [dataSource]="withdrawalDataSource" matSort #withdrawalSort="matSort" class="data-table">
          <ng-container matColumnDef="timestamp">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Datum</th>
            <td mat-cell *matCellDef="let row">{{ row.timestamp | date:'dd.MM.yyyy HH:mm' }}</td>
          </ng-container>

          <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Benutzer</th>
            <td mat-cell *matCellDef="let row">{{ row.userName }}</td>
          </ng-container>

          <ng-container matColumnDef="elementName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Material</th>
            <td mat-cell *matCellDef="let row">{{ row.element?.bezeichnung || 'Element #' + row.elementID }}</td>
          </ng-container>

          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Menge</th>
            <td mat-cell *matCellDef="let row">{{ row.quantity }}</td>
          </ng-container>

          <ng-container matColumnDef="purpose">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Zweck</th>
            <td mat-cell *matCellDef="let row">{{ row.purpose }}</td>
          </ng-container>

          <ng-container matColumnDef="comments">
            <th mat-header-cell *matHeaderCellDef>Kommentar</th>
            <td mat-cell *matCellDef="let row">{{ row.comments }}</td>
          </ng-container>

          <ng-container matColumnDef="isReturned">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Zurückgegeben</th>
            <td mat-cell *matCellDef="let row">
              <mat-icon [class.returned]="row.isReturned" [class.not-returned]="!row.isReturned">
                {{ row.isReturned ? 'check_circle' : 'cancel' }}
              </mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="withdrawalColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: withdrawalColumns;"></tr>
        </table>

        <div class="no-data" *ngIf="withdrawalDataSource.data.length === 0 && !isLoading">
          Keine Entnahmen im gewählten Zeitraum.
        </div>

        <mat-paginator #withdrawalPaginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="25"></mat-paginator>
      </div>
    </mat-tab>

    <!-- Rückgaben Tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>add_shopping_cart</mat-icon>&nbsp;Rückgaben ({{ returnDataSource.data.length }})
      </ng-template>

      <div class="table-wrapper">
        <table mat-table [dataSource]="returnDataSource" matSort #returnSort="matSort" class="data-table">
          <ng-container matColumnDef="timestamp">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Datum</th>
            <td mat-cell *matCellDef="let row">{{ row.timestamp | date:'dd.MM.yyyy HH:mm' }}</td>
          </ng-container>

          <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Benutzer</th>
            <td mat-cell *matCellDef="let row">{{ row.userName }}</td>
          </ng-container>

          <ng-container matColumnDef="elementName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Material</th>
            <td mat-cell *matCellDef="let row">{{ row.element?.bezeichnung || 'Element #' + row.elementID }}</td>
          </ng-container>

          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Menge</th>
            <td mat-cell *matCellDef="let row">{{ row.quantity }}</td>
          </ng-container>

          <ng-container matColumnDef="reason">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Grund</th>
            <td mat-cell *matCellDef="let row">{{ row.reason }}</td>
          </ng-container>

          <ng-container matColumnDef="comments">
            <th mat-header-cell *matHeaderCellDef>Kommentar</th>
            <td mat-cell *matCellDef="let row">{{ row.comments }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="returnColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: returnColumns;"></tr>
        </table>

        <div class="no-data" *ngIf="returnDataSource.data.length === 0 && !isLoading">
          Keine Rückgaben im gewählten Zeitraum.
        </div>

        <mat-paginator #returnPaginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="25"></mat-paginator>
      </div>
    </mat-tab>

    <!-- Aktivitäten Tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>history</mat-icon>&nbsp;Aktivitäten ({{ activityDataSource.data.length }})
      </ng-template>

      <div class="table-wrapper">
        <table mat-table [dataSource]="activityDataSource" matSort #activitySort="matSort" class="data-table">
          <ng-container matColumnDef="timestamp">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Datum</th>
            <td mat-cell *matCellDef="let row">{{ row.timestamp | date:'dd.MM.yyyy HH:mm' }}</td>
          </ng-container>

          <ng-container matColumnDef="userId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Benutzer</th>
            <td mat-cell *matCellDef="let row">{{ getUserName(row.userId) }}</td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Aktion</th>
            <td mat-cell *matCellDef="let row">{{ row.action }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="activityColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: activityColumns;"></tr>
        </table>

        <div class="no-data" *ngIf="activityDataSource.data.length === 0 && !isLoading">
          Keine Aktivitäten im gewählten Zeitraum.
        </div>

        <mat-paginator #activityPaginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="25"></mat-paginator>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
